import { Component, OnInit } from '@angular/core';
import { ConsultaService } from '../../services/consulta.service';
import { CategoriasService } from '../../services/categorias.service';
import { Router } from '@angular/router';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { URL_IMG } from '../../../conf/url.servicios';
import { ActivatedRoute } from '@angular/router';
import { resolve } from 'path';

declare var jquery: any;
declare var $: any;
declare var bootbox: any;

class Categoria {
  idMarca: any;
  idImagen: any;
  clave: any;
  nombre: any;
  descripcion: any;
  orden: any;
  id: any;
}

class Item {
  N_CAT_PADRE: any;
  N_ESTATUS: any;
  N_ID: any;
  N_IDIMAGEN: any;
  N_IDMARCA: any;
  N_ORDEN: any;
  S_CLAVE: any;
  S_DESCRIPCION: any;
  S_NOMBRE: any;
  S_RUTA: any;
  claveImg: any;
  descripcionImg: any;
  idImagen: any;
}

class ImagenTabla {
  clave: string;
  descripcion: string;
  ruta: string;
  tipo: number;
  id: number;
}

class RelacionImgMC {
  idImagen: number;
  idMC: number;
}



@Component({
  selector: 'app-administra-img-mc',
  templateUrl: './administra-img-mc.component.html',
  styleUrls: ['./administra-img-mc.component.css']
})
export class AdministraImgMcComponent implements OnInit {

  constructor(private router: Router, private fb: FormBuilder, private consultaService: ConsultaService,
    private categoriasService: CategoriasService, private activatedRoute: ActivatedRoute) {
      this.createForm();
  }


  rutaImagen = URL_IMG;
  title = "Administración de Imagenes";
  imagenes: any = [];
  categoria: any = {};
  itemEdicion: Item;
  itemNew: ImagenTabla;
  idImg: any;
  loading: boolean;
  extension: any;
  rutaEliminar: any;
    form: FormGroup;

    ngOnInit() {

      this.activatedRoute.params.subscribe(params => {
        this.categoria.nombre=(params['nombre']);
          this.categoria.id=(params['idCategoria']);
          this.obtieneImagenes(this.categoria.id);
        console.log(this.categoria);

      });

      this.itemEdicion = this.initItem(this.itemEdicion);
      this.itemNew = this.initItem(this.itemNew);

    }

    initItem(item): any {
      item = new Item();
      item.claveImg = "";
      item.descripcionImg = "";
      item.idImagen = "";
      item.N_ESTATUS = "";
      item.N_ID = "";
      item.N_IDMARCA_CATEGORIA = "";
      item.N_IDSEXO = "";
      item.N_PRECIO = "";
      item.S_CLAVE = "";
      item.S_DESCRIPCION
      item.S_NOMBRE = "";
      item.S_RUTA = "";
      return item;
    }

    /**
   * Image form
   */
    createForm() {
      this.form = this.fb.group({
        name: ['', Validators.required],
        avatar: null,
        carpeta: "categorias"
      });
    }


    obtieneImagenes(idProducto:any){
      this.categoriasService.obtieneImagenes(idProducto).then(resolve=>{
        this.imagenes=this.categoriasService.imagenes;
      })
    }

    goBack(){
      this.router.navigate(['/administraCategorias', 1]);
    }

    initModalEdicion(item) {
      console.log("Item editar");
      console.log(item);
      this.itemEdicion = item;
      console.log("itemEdicion",this.itemEdicion);
    }


    cambiarImagen() {
      this.rutaEliminar = this.itemEdicion.S_RUTA;
      this.itemEdicion.S_RUTA = "";
    }

    getNewFileName(formParam) {
      var fileNameAux = formParam.avatar.filename;
      this.extension = fileNameAux.split('.').pop();
      var valReplace = "." + this.extension;
      var newFileName = fileNameAux.replace(valReplace, "");
      return newFileName + Date.now() + "." + this.extension;
    }

    /**
    * File change
    * @param event
    */
    onFileChange(event) {
      let reader = new FileReader();
      if (event.target.files && event.target.files.length > 0) {
        let file = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.form.get('avatar').setValue({
            filename: file.name,
            filetype: file.type,
            value: reader.result.split(',')[1]
          })
        };
      }
    }

    isValidForm() {
      var valido = true;
      const formModel = this.form.value;

      if (formModel.name.length == 0 || formModel.avatar == null) {
        valido = false;
      }
      return valido;
    }

    actualizarImagen() {

      console.log("Editar");

      //Adjunta imagen

      var rutaImagen = "";
      const formModel = this.form.value;
      this.loading = true;
      console.log(formModel);
      formModel.avatar.filename = this.getNewFileName(formModel);

      //Borra ruta del servidor

      this.consultaService.borraImagen(this.rutaEliminar);

      //adjunta la imagen

      this.consultaService.guardarImagen(formModel).then(resolve => {
        console.log(resolve);
        if (resolve) {

          rutaImagen = this.consultaService.rutaImagen;

          //Guarda ruta imagen en tabla

          var imgTbl = new ImagenTabla();
          imgTbl.clave = "";
          imgTbl.descripcion = formModel.name;
          imgTbl.ruta = rutaImagen;
          imgTbl.tipo = 2;
          imgTbl.id = this.itemEdicion.idImagen;
          this.consultaService.actualizaImagenTabla(imgTbl).then(resolve => {
            bootbox.alert("<strong>Alerta</strong><br/><br/> Información guardada correctamente");
            this.reloadImagenes();
          });
        }
      });

    }


    reloadImagenes(){
      this.obtieneImagenes(this.categoria.id);
    }



    initModalNew() {
      this.itemNew = new ImagenTabla();
      this.itemNew.clave = "";
      this.itemNew.descripcion = "";
      this.itemNew.id = null;
    }

    guardarImagen() {
      console.log("Editar");
      //Adjunta imagen
      var rutaImagen = "";
      const formModel = this.form.value;
      this.loading = true;
      console.log(formModel);
      formModel.avatar.filename = this.getNewFileName(formModel);

      //adjunta la imagen
      this.consultaService.guardarImagen(formModel).then(resolve => {
        console.log(resolve);
        if (resolve) {
          rutaImagen = this.consultaService.rutaImagen;
          //Guarda ruta imagen en tabla
          var imgTbl = new ImagenTabla();
          imgTbl.clave = "";
          imgTbl.descripcion = formModel.name;
          imgTbl.ruta = rutaImagen;
          imgTbl.tipo = 2;
          this.consultaService.guardaImagenTabla(imgTbl).then(resolve => {
          this.idImg = this.consultaService.idImg;
          //Guarda la relacion imagen-blog
          var rel = new RelacionImgMC();
          rel.idMC = this.categoria.id;
          rel.idImagen = this.idImg;

          this.categoriasService.guardaRelacionImgMC(rel).then(resolve => {
            bootbox.alert("<strong>Alerta</strong><br/><br/> Información guardada correctamente");
            this.reloadImagenes();
          });


          });
        }
      });

    }

    eliminarImg(item:any){
      console.log(item);
      this.categoriasService.eliminarImgSeccategoria(item).then(resolve=>{
        bootbox.alert("<strong>Alerta</strong><br/><br/> Información guardada correctamente");
        this.reloadImagenes();
      })

    }

}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/components/administra-img-mc/administra-img-mc.component.ts